import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import rhService, { Employe } from '../../api/rh';
import { formatTND } from '../../utils/formatters';

const CARDS: { to: string; title: string; desc: string }[] = [
  { to: '/rh/employes', title: 'Salariés', desc: 'Répertoire du personnel : contrats, CNSS, salaires de base' },
  { to: '/rh/conges', title: 'Congés', desc: 'Demandes, validation et solde annuel de congés payés' },
  { to: '/rh/paie', title: 'Paie', desc: 'Bulletins mensuels (CNSS, IRPP, CSS) → écriture comptable' },
];

const Rh: React.FC = () => {
  const [employes, setEmployes] = useState<Employe[]>([]);

  useEffect(() => {
    rhService
      .listEmployes(false)
      .then(setEmployes)
      .catch((e: any) => {
        if (e?.response?.status !== 403) toast.error('Impossible de charger le module RH.');
      });
  }, []);

  const actifs = employes.filter((e) => e.actif);
  const masseSalariale = actifs.reduce((s, e) => s + Number(e.salaireBaseBrut || 0), 0);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Ressources humaines</h1>
        <p className="text-sm text-gray-500">
          Gestion du personnel, des congés et de la paie tunisienne (CNSS, IRPP, CSS),
          avec génération automatique de l'écriture comptable de salaires.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-white p-5 rounded-xl border border-gray-200">
          <div className="text-sm text-gray-500">Salariés actifs</div>
          <div className="text-2xl font-bold text-gray-900">{actifs.length}</div>
        </div>
        <div className="bg-white p-5 rounded-xl border border-gray-200">
          <div className="text-sm text-gray-500">Effectif total</div>
          <div className="text-2xl font-bold text-gray-900">{employes.length}</div>
        </div>
        <div className="bg-white p-5 rounded-xl border border-gray-200">
          <div className="text-sm text-gray-500">Masse salariale brute (base / mois)</div>
          <div className="text-2xl font-bold text-gray-900">{formatTND(masseSalariale)}</div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CARDS.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="block bg-white p-5 rounded-xl border border-gray-200 hover:border-blue-400 hover:shadow-sm transition"
          >
            <div className="font-semibold text-gray-900">{c.title}</div>
            <div className="text-sm text-gray-500 mt-1">{c.desc}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Rh;
